export default __webpack_public_path__ + "static/media/maitre_gims_est-ce_que_tu_m_aimes.570aeaab.mp3";